const runListener = (listener: EventListenerOrEventListenerObject, e: Event): void|EventListener => 'handleEvent' in listener
    ? listener.handleEvent(e)
    : listener(e);

export function wrapPreventDefault(listener: EventListenerOrEventListenerObject) {
    return function (e: Event): void {
        if (!e.defaultPrevented) {
            e.preventDefault();
        }
        runListener(listener, e);
    }
}

export function createEvent(type: string): Event {
    let event: Event;

    if (typeof Event !== 'function') {
        event = document.createEvent('Event');
        event.initEvent(type);
    } else {
        event = new Event(type);
    }

    return event;
}

// https://hacks.mozilla.org/2013/04/detecting-touch-its-the-why-not-the-how/
export function addClickEventListener(element: Node, listener: EventListenerOrEventListenerObject, options?: AddEventListenerOptions): void {
    element.addEventListener('click', listener, options);
}

const wrapSelectorWithChildren = (selector: string): string => `${selector}, ${selector} *`;

export function addDocumentTargetClickEventListener(selector: string, listener: EventListenerOrEventListenerObject, options?: AddEventListenerOptions): void {
    addClickEventListener(document, event => {
        if (event.target === null) {
            return;
        }

        if ((<HTMLElement>event.target).matches(wrapSelectorWithChildren(selector))) {
            runListener(listener, event);
        }
    }, options);
}

export function removeClickEventListener(element: Node, listener: EventListenerOrEventListenerObject, options?: AddEventListenerOptions): void {
    element.removeEventListener('click', listener, options);

    if ('ontouchstart' in window) {
        element.removeEventListener('touchend', wrapPreventDefault(listener), options);
    }
}
